import { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';

export type OlProps = CommonHTMLAttributes & {
  children: React.ReactNode;
};

const nakedOlStyles = css`
  list-style-type: none;
  padding-left: 0;
`;

export const NakedOl = forwardRef<HTMLOListElement, OlProps>(({ children, className, ...rest }, ref) => (
  <ol className={cx(nakedOlStyles, className)} {...rest} ref={ref}>
    {children}
  </ol>
));

NakedOl.displayName = 'NakedOl';
